<template lang="pug">
  div
    form.w-full.max-w-xl.mt-6(v-on:submit="startSending")
      .flex.flex-wrap.-mx-3
        .w-full.px-3
          label(for='address') Address
          input#address(placeholder='0.0.0.0' type="text" v-model="address" v-bind:disabled="sending")
          p.text-gray-600.text-xs.italic Both IPv4 and IPv6 addresses are supported.
      input.button.mt-3(type="submit" v-bind:disabled="loading" v-bind:class="{ 'opacity-50': loading }" value="Send")
      button(class="button bg-red-600 hover:bg-red-400 ml-4 mt-3" v-if="sending" v-on:click="stopSending") Cancel
    div.text-gray-100.font-mono.bg-black.text-xs.rounded.p-4.mt-6(class="md:text-base" v-if="hasError || (responses && responses.length > 0)")
      div.text-red-400(v-if="hasError") {{errorMessage}}
      div.grid.grid-cols-4.max-w-3xl(v-else)
        div(v-for="val in flatResponses") {{val}}

</template>
<script>
import common_computed from "@/mixins/common_computed";
import errors from "@/mixins/errors";

export default {
  mixins: [common_computed, errors],
  data() {
    return {
      address: "",
      ttl: 0,
      sending: false,
      responses: [],
    };
  },
  computed: {
    ipType() {
      if (this.address.match(/^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/)) {
        return "ipv4";
      } else {
        return "ipv6";
      }
    },
    flatResponses() {
      return this.responses
        .map((set) => {
          return [
            this.sourceString(set),
            this.responseString(set[0]),
            this.responseString(set[1]),
            this.responseString(set[2]),
          ];
        })
        .flat();
    },
  },
  beforeDestroy() {
    if (this.sending || this.loading) {
      this.stopSending();
    }
  },
  methods: {
    startSending(e) {
      e.preventDefault();
      if (this.sending) {
        this.stopSending();
      }

      this.responses = [];
      this.clearError();

      this.sending = true;
      this.loading = true;
      this.ttl = 0;

      this.sendEchoes();
    },
    stopSending() {
      this.loading = false;
      this.sending = false;
    },
    sendEchoes() {
      this.ttl++;
      fetch(`${this.selectedHost}/v1/icmp/${this.ipType}`, {
        method: "POST",
        body: JSON.stringify({
          requests: [
            {
              host: this.address,
              ttl: this.ttl,
            },
            {
              host: this.address,
              ttl: this.ttl,
            },
            {
              host: this.address,
              ttl: this.ttl,
            },
          ],
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((resp) => {
          if (!resp.ok) {
            this.hasError = true;
          }
          return resp.json();
        })
        .then((json) => {
          console.log(json);
          if (this.hasError) {
            this.stopSending();
            this.setError(json.error.description);
          } else if (json.responses && json.responses.length) {
            this.responses.push(json.responses);
            if (this.containsFinal(json.responses) || this.ttl === 30) {
              this.stopSending();
            } else if (this.sending) {
              this.sendEchoes();
            }
          }
        })
        .catch((error) => {
          console.error(error);
          this.setError("Unable to perform echo, an error occurred");
        });
    },
    containsFinal(responseSet) {
      const finalIndex = responseSet.findIndex((response) => {
        return response !== null && response.type === "success";
      });

      return finalIndex !== -1;
    },
    sourceString(responseSet) {
      const sourceIndex = responseSet.findIndex((response) => {
        return response !== null;
      });

      if (sourceIndex === -1) {
        return "";
      } else {
        return `${responseSet[sourceIndex].source}:`;
      }
    },
    responseString(response) {
      if (
        response &&
        (response.type === "success" || response.type === "ttl_expired")
      ) {
        return `${(response.time * 1000.0).toFixed(2)} ms`;
      } else {
        return "*";
      }
    },
  },
};
</script>
